import { AfterViewInit, Component } from '@angular/core';
import { DefaultEditor } from 'angular2-smart-table';
import { ConfirmEditInfo, MultiSelectCheckBoxService } from './multi-select-check-box.service';

@Component({
  template: `
    <ng-container *ngIf="checked;else unchecked">
      <nb-checkbox (checkedChange)="toggle($event)" [checked]="checked"></nb-checkbox>
    </ng-container>
    <ng-template #unchecked>
    <nb-checkbox (checkedChange)="toggle($event)" disabled></nb-checkbox>
    </ng-template>
  `,
})
export class OfbizCheckBoxEditorComponent extends DefaultEditor implements AfterViewInit {
  checked:boolean;
  rowIndex:number;
  id:string;
  
  constructor(private multiSelectCheckBoxService:MultiSelectCheckBoxService) { 
    super()
    
  }

  ngOnInit(): void {
    this.rowIndex = this.cell.getRow().index
  }

  ngAfterViewInit(): void {
    //Nothing here
    //this.cell.setValue(true);
    //this.checked = true;
    //this.rowIndex = this.cell.getRow().index;
    console.log({CellValue:this.cell.getValue(),index:this.rowIndex});
    /* this.multiSelectCheckBoxService.getConfirmEditData()
    .subscribe((confirmEditInfo:ConfirmEditInfo) => {
      if(confirmEditInfo != null){
        console.log({ConfirmEditData:confirmEditInfo});
        if(confirmEditInfo.rowIndex != undefined && confirmEditInfo.rowIndex == this.rowIndex){
          let data = confirmEditInfo.confirmEditData.data;
          let newData = confirmEditInfo.confirmEditData.newData;
          let isSame:boolean = this.deepCompare(data,newData);
          console.log({isSame:isSame,SelectedRowIndex:this.rowIndex,EditRowIndex:confirmEditInfo.rowIndex})
          if(isSame){
            this.checked = false;
          }else{
            this.checked = true;
            this.cell.setValue(true);
          }
        }else{
          console.log({RowDifference:{SelectedRowIndex:this.rowIndex,EditRowIndex:confirmEditInfo.rowIndex}});
        }
      }else{
        this.checked = this.cell.getValue();
      }
    }) */
    this.onStopEditing.subscribe(data => {
      console.log({OnStopEditing:data})
    })
    this.onEdited.subscribe(data => {
      console.log({OnStopEditing:data})
    })
  }
  toggle(e){
    this.checked != this.checked;
    this.cell.setValue(e);
    console.log({Checked:e,cell:this.cell});
    /**
     * This is commented out as it throws an error on DefaultEditor in angular2-smart-table
     * Don't know what the impact of this is yet, but will see
     */
    //this.onEdited.emit({value:this.checked,cell:this.cell});
    this.onEdited.emit();

  }

  stopEditing(e){
    console.log(e)
  }

  deepCompare(obj1: any,
    obj2: any,
    compareOrder: boolean = false):boolean{
      if (typeof obj1 !== typeof obj2) return false;
    if ((typeof obj1 === "string" || typeof obj1 === "number") && obj1 !== obj2) return false;
    console.log({Object1Before:obj1})
    delete obj1.checkbox
    const o1 = Object.entries(obj1);
    console.log({Object1After:o1})
    const o2 = Object.entries(delete obj2.checkbox)
    const compare = (first: [string, unknown][], second: [string, unknown][]) => {
        return first.every((value, index): boolean => {
            const secondIndex = second.findIndex(val => val[0] === value[0])
            if ((compareOrder && index !== secondIndex) || secondIndex === -1) return false;
            const [k1, v1] = value
            const [k2, v2] = second[secondIndex]
            if (k1 !== k2) return false;
            if (typeof v1 === "object" || typeof v2 === "object") return this.deepCompare(v1, v2);
            if (v1 !== v2) return false;
            return true;
        })
    }
    return compare(o1, o2)
  }

}
